import { defineComponent, h } from "vue";

import { Teleport } from "vue";

export const UiPanel = defineComponent({
  name: "Panel",
  props: { header: String },
  setup(props, { slots }) {
    return () =>
      h(
        "section",
        {
          class:
            "rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]",
        },
        [
          props.header
            ? h(
                "div",
                {
                  class:
                    "border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white px-4 py-4 text-[15px] font-bold text-slate-900",
                },
                props.header,
              )
            : null,
          h("div", { class: "p-4" }, slots.default?.()),
        ],
      );
  },
});

export const UiCard = defineComponent({
  name: "Card",
  setup(_, { slots }) {
    return () =>
      h(
        "div",
        {
          class:
            "rounded-lg border border-slate-200 bg-white shadow-[0_10px_26px_rgba(15,23,42,0.06)]",
        },
        [
          slots.title
            ? h(
                "div",
                {
                  class:
                    "border-b border-slate-200 bg-slate-50 px-4 py-3 font-bold text-slate-900",
                },
                slots.title(),
              )
            : null,
          h(
            "div",
            { class: "p-4" },
            slots.content ? slots.content() : slots.default?.(),
          ),
        ],
      );
  },
});

export const UiDialog = defineComponent({
  name: "Dialog",
  inheritAttrs: false,
  props: {
    visible: Boolean,
    header: String,
    contentClass: String,
    closable: { type: Boolean, default: true },
  },
  emits: ["update:visible"],
  setup(props, { slots, emit, attrs }) {
    return () =>
      props.visible
        ? h(Teleport, { to: "body" }, [
            h(
              "div",
              {
                class:
                  "fixed inset-0 z-[5000] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-[2px]",
              },
              [
                h(
                  "div",
                  {
                    class:
                      "flex max-h-[90vh] w-full max-w-6xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl",
                    style: attrs.style,
                  },
                  [
                    h(
                      "div",
                      {
                        class:
                          "flex shrink-0 items-center justify-between border-b border-slate-200 bg-slate-50 px-6 py-4",
                      },
                      [
                        h(
                          "p",
                          { class: "text-xl font-semibold text-slate-900" },
                          props.header || "",
                        ),
                        props.closable
                          ? h(
                              "button",
                              {
                                class:
                                  "inline-flex h-9 w-9 items-center justify-center rounded-lg text-sm leading-none text-slate-500 transition hover:bg-white hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-teal-200",
                                onClick: () => emit("update:visible", false),
                              },
                              [h("i", { class: "pi pi-times text-xs" })],
                            )
                          : null,
                      ],
                    ),
                    h(
                      "div",
                      {
                        class: [
                          "min-h-0 flex-1 overflow-auto p-6",
                          props.contentClass,
                        ],
                      },
                      slots.default?.(),
                    ),
                    slots.footer
                      ? h(
                          "div",
                          {
                            class:
                              "flex shrink-0 justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 py-4",
                          },
                          slots.footer(),
                        )
                      : null,
                  ],
                ),
              ],
            ),
          ])
        : null;
  },
});
